import { render, staticRenderFns } from "./BidStepForm.vue?vue&type=template&id=10a458b4"
import script from "./BidStepForm.vue?vue&type=script&lang=js"
export * from "./BidStepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports